import React from 'react';
import PropTypes from 'prop-types';
import hansepayWhiteLogo from '../../assets/hansepay-white.png';

function OnboardingTopNav({ onExit }) {
  return (
    <header className='flex h-[60px] shrink-0 items-center justify-between bg-[linear-gradient(135deg,#060D1A_0%,#0F2540_55%,#163659_100%)] px-5 sm:px-10'>
      <a href='/' className='flex items-center gap-2.5 no-underline'>
        <img src={hansepayWhiteLogo} width={26} height={26} alt='HansePay' className='block shrink-0' />
        <span className='wordmark inline-block translate-y-px text-[17px] leading-none tracking-[-0.01em] text-white'>HansePay</span>
      </a>
      <button type='button' onClick={onExit} className='text-[12.5px] font-medium text-white/45 transition hover:text-white/75'>
        Save &amp; exit
      </button>
    </header>
  );
}

OnboardingTopNav.propTypes = {
  onExit: PropTypes.func.isRequired,
};

export default OnboardingTopNav;
